import React from "react";
import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import FAQAccordion from "@/components/FAQAccordion";
import { GENERAL_FAQS } from "@/data/faqs";
import { SITE } from "@/lib/site";

export default function HomeFAQSection() {
  return (
    <section className="section-pad bg-white">
      <div className="container-br grid lg:grid-cols-2 gap-10">
        <div>
          <div className="br-eyebrow">Common Questions</div>
          <h2 className="br-headline text-3xl sm:text-4xl mt-3">Frequently Asked Questions</h2>
          <p className="mt-3 text-gray-700">Quick answers about how we work. Don't see your question? Just ask.</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to="/contact" className="br-btn-dark">Contact Us</Link>
            <a href={`tel:${SITE.phoneE164}`} className="br-btn-secondary" style={{color:"#0a0a0a", borderColor:"#0a0a0a"}}><Phone size={14}/> {SITE.phone}</a>
          </div>
        </div>
        <div><FAQAccordion faqs={GENERAL_FAQS.slice(0,8)} /></div>
      </div>
    </section>
  );
}
